<div class="pos-panel">
    <div class="pos-panel-header">
        <span class="soc-panel-header">{{'TAX_RATE.SERVICE' | translate}}</span>
        <hr class="soc-panel-line" />
    </div>
    <div class="d-flex justify-content-between">
        <span class="soc-h4">{{'TAX_RATE.TAX_RATES' | translate}}</span>
    </div>
    <hr class="soc-panel-line" />
    <div *ngIf="taxRates && (taxRates.length > 0 || searchTaxRate != '' || loading)" class="soc-wrapper-gap-24-column">
        <div class="pos-actions-wrapper">
            <div class="soc-search-wrapper">
                <div class="p-inputgroup soc-search-field-wrapper">
                    <i class="pi pi-search soc-neutral-text-color"></i>
                    <input type="text" class="soc-search-input-field soc-input-text" [(ngModel)]="searchTaxRate" (ngModelChange)="searchTermChange()" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <button class="soc-basic-cyan-btn" (click)="addTaxRate()"><span
                class="tax-icon nav-icon"  style="width: 17px; height: 19px; background-color: var(--app-mono-background-light);"></span>{{'TAX_RATE.CREATE_TAX_RATE' | translate}}</button>
        </div>
        <hr class="soc-panel-line" />
    </div>
    <div *ngIf="taxRates && taxRates.length == 0 && searchTaxRate == '' && !loading" class="pos-no-entities-wrapper">
        <div class="pos-no-entities-indicator" style="width: 500px;">
            <span class="tax-icon nav-icon"
                style="width: 67px; height: 67px; background-color: var(--soc-cyan);"></span>
            <span class="soc-h2 text-center">{{'TAX_RATE.TAX_RATES' | translate}}</span>
            <span class="soc-p text-center" style="white-space: pre-line;">{{'TAX_RATE.CREATE_TAX_RATE_TEXT' |
                translate}}</span>
            <button class="soc-basic-cyan-btn" (click)="addTaxRate()">{{'TAX_RATE.CREATE_TAX_RATE' |
                translate}}</button>
        </div>
    </div>
    <div *ngIf="!taxRates || loading" class="soc-loading-wrapper">
        <p-progressSpinner strokeWidth="4"></p-progressSpinner>
    </div> 
    <div *ngIf="taxRates && taxRates.length > 0 && !loading" class="soc-content-panel-wrapper">
        <div style="display: flex;height: calc(100vh - 418px);overflow: auto;flex-direction: column;gap: 24px;">
            <div class="pos-panel-cards-wrapper">
                <ng-container *ngFor="let taxRate of taxRates">
                    <div class="soc-card ">
                        <span class="tax-icon nav-icon "
                            style="width: 40px; height: 40px; background-color: var(--soc-cyan);"></span>
                        <div class="soc-card-info">
                            <div class="d-flex justify-content-between w-100">
                                <div class="soc-card-title">
                                    <span class="soc-h2">{{taxRate.name}}</span>
                                </div>
                                <span class="material-icons neutral-90 "
                                    (click)="$event.stopPropagation(); actionMenu.toggle($event)">more_vert</span>
                                <p-overlayPanel #actionMenu [dismissable]="true" class="d-none">
                                    <div class="soc-action-menu-content">
                                        <div class="soc-action-item" (click)="editTaxRate(taxRate)">
                                            {{'TAX_RATE.EDIT_TAX_RATE' | translate}}</div>
                                        <div class="soc-action-item" (click)="deleteTaxRate(taxRate)">
                                            {{'TAX_RATE.DELETE_TAX_RATE' | translate}}</div>
                                    </div>
                                </p-overlayPanel>

                            </div>
                            <div class="d-flex justify-content-between w-100 gap-4">
                                <div class="soc-wrapper-gap-12-column w-50">
                                    <div class="soc-card-subtitle">
                                        <span class="soc-display-lbl w-100">{{'TAX_RATE.TAX_RATE_PERCENTAGE' |translate}}</span>
                                    </div>
                                    <hr class="soc-split-line">
                                    <label _ngcontent-ley-c309="" class="soc-lbl-text-16 soc-neutral-50-text-color"
                                        style="height: 24px;">{{taxRate.rate}}%</label>
                                </div>
                                <div class="soc-wrapper-gap-12-column w-50">
                                    <div class="soc-card-subtitle">
                                        <span class="soc-display-lbl w-100">{{'TAX_RATE.DESCRIPTION' |translate}}</span>
                                    </div>
                                    <hr class="soc-split-line">
                                    <label _ngcontent-ley-c309="" class="soc-lbl-text-16 soc-neutral-50-text-color"
                                        style="height: 24px;">{{taxRate.description}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<p-confirmDialog class="soc-confirmation-dialog">
</p-confirmDialog>